/**
 * Legacy delayed-handover monitor.
 *
 * The app now uses the white `HandoverReminderOverlay` for delayed handovers,
 * so this service stays as a no-op compatibility shim to prevent the orange
 * warning notifications from appearing twice.
 */
class HandoverDelayChecker {
  private static checkInterval: number | null = null;

  static startMonitoring(): void {
    this.stopMonitoring();
  }

  static stopMonitoring(): void {
    if (this.checkInterval) {
      clearInterval(this.checkInterval);
      this.checkInterval = null;
    }
  }

  static clearNotification(_bookingId: string): void {
    // Intentionally empty.
  }

  static resetNotifications(): void {
    // Intentionally empty.
  }

  static getNotifiedCount(): number {
    return 0;
  }
}

export default HandoverDelayChecker;
